export default "__VITE_PUBLIC_ASSET__8b8c46eb__"